import { ModalNames } from "~/jsx/context/ModalNames";
import { FontSize, Spacing } from "~/jsx/theme";
import { XHistoryEvent, XModal, XTypography, XGameEvent } from "../design";
import { useGame } from "~/app";
import { Game, GameCommandByPlayer, GameInfoEvent } from "~/business";
import { UndoState } from "@rauricoste/discrete-game";

export const XHistoryModal = () => {
  const { history } = useGame();

  type State = { gameState: Game; undoState: UndoState };
  const { events: steps } = history.steps.reduce<{
    previousState: State;
    events: {
      command: GameCommandByPlayer;
      events: GameInfoEvent[];
      beforeCommandState: State;
      afterCommandState: State;
    }[];
  }>(
    (acc, step) => {
      const { previousState: previousGame } = acc;
      acc.events.push({
        command: step.command,
        events: step.state.gameState.infoEvents,
        beforeCommandState: previousGame,
        afterCommandState: step.state,
      });
      acc.previousState = step.state;
      return acc;
    },
    { previousState: history.initState, events: [] }
  );
  return (
    <XModal name={ModalNames.history}>
      <div style={{ padding: 20 }}>
        <XTypography style={{ marginBottom: "1em", fontSize: FontSize.px24 }}>
          History
        </XTypography>
        <div
          style={{
            overflowY: "scroll",
            maxHeight: "75vh",
            display: "flex",
            flexDirection: "column",
            gap: Spacing.px8,
            padding: Spacing.px12,
          }}
        >
          {steps
            .flatMap(
              (
                {
                  afterCommandState: afterCommandGame,
                  beforeCommandState: beforeCommandGame,
                  command,
                  events,
                },
                stepIndex
              ) => {
                return [
                  <XHistoryEvent
                    key={`command_${stepIndex}`}
                    content={XGameEvent({
                      event: {
                        ...command,
                        game: beforeCommandGame.gameState,
                        undoState: beforeCommandGame.undoState,
                      },
                    })}
                  />,
                  ...events.map((event, eventIndex) => (
                    <XHistoryEvent
                      key={`command_${stepIndex}_event_${eventIndex}`}
                      content={XGameEvent({
                        event: {
                          ...event,
                          game: afterCommandGame.gameState,
                          undoState: afterCommandGame.undoState,
                          isInfo: true,
                        },
                      })}
                    />
                  )),
                ].filter((_) => _ !== null);
              }
            )
            .reverse()}
        </div>
      </div>
    </XModal>
  );
};
